import { Action, createReducer, on } from '@ngrx/store';
import { getErrorText, IError } from '@app-root-interfaces';
import * as errorActions from '../actions/error.actions';

export const errorFeatureKey = 'error';

export interface State {
    current: IError[];
    previous: IError[];
}

export const initialState: State = {
    current: [],
    previous: []
};

const errorReducer = createReducer(
    initialState,
    on(errorActions.addError, (state, { error }) => {
        if (state.current.some((err) => errorsAreEqual(error, err))) {
            return state;
        }

        return {
            ...state,
            current: [...state.current, error]
        };
    }),
    on(errorActions.nextError, (state) => {
        if (!state.current.length) {
            return state;
        }

        return {
            ...state,
            previous: [state.current[0], ...state.previous].slice(-10),
            current: state.current.slice(1)
        };
    })
);

function errorsAreEqual(error: IError, current: IError) {
    if (!error || !current) {
        return false;
    }
    return (
        error.isCritical === current.isCritical &&
        // && getErrorText(error.obj) === current.obj
        getErrorText(error.text) === getErrorText(current.text) &&
        error.timer === current.timer
    );
}

export function reducer(state: State | undefined, action: Action) {
    return errorReducer(state, action);
}
